export const GET_NEW_RECURRING_REVENUE = "GET_NEW_RECURRING_REVENUE"
export const GET_NEW_RECURRING_REVENUE_SUCCESS = "GET_NEW_RECURRING_REVENUE_SUCCESS"
export const GET_NEW_RECURRING_REVENUE_FAIL = "GET_NEW_RECURRING_REVENUE_FAIL"
